import { useState } from "react";
import { deleteHttp, put } from "@common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useMessageBubbleFeedback(messageId: string, initialIsPositive?: boolean | null) {
    const [isPositive, setIsPositive] = useState<boolean | null>(initialIsPositive ?? null);
    const [pendingIsPositive, setPendingIsPositive] = useState<boolean | null>(null);
    const [comment, setComment] = useState("");

    const setFeedbackMutation = useDotLegalMutation<void, { isPositive: boolean; comment?: string }>(async (feedback) => {
        await put(`/ai-chat/messages/${messageId}/feedback`, feedback);
    });

    const clearFeedbackMutation = useDotLegalMutation<void, void>(async () => {
        await deleteHttp(`/ai-chat/messages/${messageId}/feedback`);
    });

    function onThumbClick(clickedPositive: boolean) {
        if (isPositive === clickedPositive) {
            setIsPositive(null);
            clearFeedbackMutation.mutate();
            return;
        }

        setComment("");
        setPendingIsPositive(clickedPositive);
    }

    function submitFeedback() {
        if (pendingIsPositive === null) return;
        setFeedbackMutation.mutate({ isPositive: pendingIsPositive, comment: comment.trim() === "" ? undefined : comment.trim() });
        setIsPositive(pendingIsPositive);
        setPendingIsPositive(null);
    }

    function closeDialog() {
        setPendingIsPositive(null);
    }

    return {
        isPositive,
        pendingIsPositive,
        comment,
        setComment,
        onThumbClick,
        submitFeedback,
        closeDialog,
    };
}
